/**
 * In-header placement for the Agent Rail.
 *
 * AgentIntegration is mounted in `EntityChrome.headerControls` — the right-
 * side toolbar of the entity header. Earlier we tried `position: fixed` on
 * the right gutter; that overlapped the existing right Sidebar (settings /
 * chat / notes / backlinks) and the user preferred the in-toolbar look.
 *
 * The header's `.toolbar` is `height: 48px; overflow: hidden`, so the rail
 * has to lay out horizontally (a column of 40-px avatars would clip after
 * the first). The rail's own CSS uses `flex-direction: column` by default
 * (with a `max-width: 720px` row variant); this class flips it to row at
 * every viewport so 1..N attached agents sit side-by-side in the toolbar.
 */
.rail {
  display: flex;
  align-items: center;
}

.rail > ul {
  flex-direction: row;
  align-items: center;
  gap: var(--tuna-spacing-0_5, 4px);
  padding: 0;
}
